import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Swal from "sweetalert2";
import { FaPaperclip } from "react-icons/fa";
import Oms from "./Oms";

ReactModal.setAppElement("#root");

/* =========================
    CONFIGURACIÓN
========================== */
const api = axios.create({
  baseURL:
    process.env.REACT_APP_SUA_API_INTERNA_URL ||
    "https://suadesarrollo.azurewebsites.net/api",
  auth: {
    username: process.env.REACT_APP_SUA_USUARIO,
    password: process.env.REACT_APP_SUA_CLAVE,
  },
});

const ESTADOS = ["Aplazado", "Terminado"];

const OPCIONES_APLICA = [
  { valor: "1", nombre: "Aplica" },
  { valor: "0", nombre: "No aplica" },
];

/** Respuesta del API como texto: tal cual si es texto, JSON con formato si es objeto. */
const aTexto = (data) => {
  if (data === undefined || data === null || data === "")
    return "(sin contenido)";
  return typeof data === "string" ? data : JSON.stringify(data, null, 2);
};

/** Valor inicial de "Aplica" a partir de la prop (acepta 1/0, "1"/"0", true/false). */
const aplicaInicial = (valor) => {
  if (valor === 0 || valor === "0" || valor === false) return "0";
  return "1";
};

/** Muestra la respuesta del API en un SweetAlert (con textContent, sin inyectar HTML). */
const mostrarRespuesta = (titulo, icono, status, data) => {
  const contenedor = document.createElement("div");

  if (status) {
    const codigo = document.createElement("small");
    codigo.textContent = `HTTP ${status}`;
    codigo.style.cssText = "display:block;color:#6c757d;margin-bottom:6px;";
    contenedor.appendChild(codigo);
  }

  const pre = document.createElement("pre");
  pre.textContent = aTexto(data);
  pre.style.cssText =
    "text-align:left;white-space:pre-wrap;font-size:13px;background:#f4f6f9;" +
    "padding:10px;border-radius:6px;max-height:300px;overflow:auto;margin:0;";
  contenedor.appendChild(pre);

  return Swal.fire({ title: titulo, icon: icono, html: contenedor });
};

function CambioEstadoTareas(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [postEstado, setPostEstado] = useState("");
  const [postAplica, setPostAplica] = useState("1");
  const [postComentarios, setPostComentarios] = useState("");
  const [error, setError] = useState(null); // { status, texto }
  const [guardando, setGuardando] = useState(false);
  const [list, setList] = useState([]);

  const noAplica = postAplica === "0";

  /* =========================
      MODAL
  ========================== */
  const handleOpenModalTest = () => {
    setPostComentarios(props.comentarios || "");
    setPostEstado(props.estado || "");
    setPostAplica(aplicaInicial(props.aplica));
    setError(null);
    setIsOpen(true);
  };

  const closeModal = () => {
    if (!guardando) setIsOpen(false);
  };

  /* =========================
      GUARDAR
  ========================== */
  const postData = async (e) => {
    e.preventDefault();
    setError(null);

    if (!postEstado) {
      setError({ texto: "Seleccione el estado de la actividad." });
      return;
    }

    if (noAplica && !postComentarios.trim()) {
      setError({
        texto:
          "Debe ingresar la justificación en Comentarios para esta actividad que no aplica.",
      });
      return;
    }

    const cuerpo = {
      EvaluadorId: Number(props.idEvaluador),
      Tarea: Number(props.idActividad ?? props.idTarea),
      SolicitudId: Number(props.idSolicitud),
      Grupo: props.grupo ?? "1",
      Estado: postEstado,
      Comentarios: postComentarios.trim(),
      InstitucionId: Number(props.idInstitucion),
      Aplica: Number(postAplica),
    };

    setGuardando(true);
    console.log(`[ActualizaTarea] PUT Id=${props.idTarea} — enviado:`, cuerpo);

    try {
      const { data, status } = await api.put("/ActualizaTarea", cuerpo, {
        params: { Id: props.idTarea },
      });

      console.log(`[ActualizaTarea] respuesta HTTP ${status}:`, data);

      setIsOpen(false);
      props.onActualizado?.(); // refresca la tabla

      mostrarRespuesta("Respuesta del servidor", "success", status, data);
    } catch (err) {
      const status = err?.response?.status;
      const data = err?.response?.data ?? err.message;

      console.error(
        `[ActualizaTarea] error HTTP ${status ?? "sin respuesta"}:`,
        data,
      );

      // Se muestra dentro del modal para que el usuario corrija y vuelva a guardar.
      setError({ status, texto: aTexto(data) });
    } finally {
      setGuardando(false);
    }
  };

  /* =========================
      ADJUNTOS
  ========================== */
  useEffect(() => {
    const controller = new AbortController();

    api
      .get(
        `/QOportunidadMejoraPorIds?TareaId=${props.idTarea}&evaluadorId=0${props.idEvaluador}&SolicitudId=${props.idSolicitud}`,
        { signal: controller.signal },
      )
      .then(({ data }) => setList(Array.isArray(data) ? data : []))
      .catch((err) => {
        if (!axios.isCancel(err)) console.log(err);
      });

    return () => controller.abort();
  }, [props.idTarea, props.idEvaluador, props.idSolicitud]);

  /* =========================
      RENDER
  ========================== */
  return (
    <div>
      <button
        type="button"
        className={`btn ${props.comentarios ? "btn-secondary" : "btn-primary"}`}
        onClick={handleOpenModalTest}
        style={{ display: "inline-flex", alignItems: "center", gap: "5px" }}
      >
        Añadir comentarios {list.length > 0 && <FaPaperclip />}
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Cambio Estado"
      >
        <div className="container text-center">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex justify-content-between align-items-center">
              <h6
                className="m-0 font-weight-bold text-primary"
                style={{ textAlign: "left" }}
              >
                Actividad: {props.nombreTarea}
              </h6>
              <button
                type="button"
                className="close"
                aria-label="Cerrar"
                onClick={closeModal}
                disabled={guardando}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="card-body" style={{ textAlign: "left" }}>
              <form className="user" onSubmit={postData}>
                <div className="form-row">
                  <div className="form-group col-md-6">
                    <label htmlFor="estado-tarea">Estado</label>
                    <select
                      id="estado-tarea"
                      className="form-control"
                      value={postEstado}
                      onChange={(e) => {
                        setPostEstado(e.target.value);
                        setError(null);
                      }}
                      disabled={guardando}
                    >
                      <option value="">Seleccione el estado</option>
                      {ESTADOS.map((estado) => (
                        <option key={estado} value={estado}>
                          {estado}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group col-md-6">
                    <label htmlFor="aplica-tarea">¿Aplica?</label>
                    <select
                      id="aplica-tarea"
                      className="form-control"
                      value={postAplica}
                      onChange={(e) => {
                        setPostAplica(e.target.value);
                        setError(null);
                      }}
                      disabled={guardando}
                    >
                      {OPCIONES_APLICA.map((o) => (
                        <option key={o.valor} value={o.valor}>
                          {o.nombre}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="comentarios-tarea">
                    {noAplica ? (
                      <>
                        Justificación{" "}
                        <span className="text-danger">(obligatoria)</span>
                      </>
                    ) : (
                      "Descripción"
                    )}
                  </label>
                  <textarea
                    id="comentarios-tarea"
                    className={`form-control ${noAplica && !postComentarios.trim() ? "is-invalid" : ""}`}
                    rows="3"
                    value={postComentarios}
                    onChange={(e) => {
                      setPostComentarios(e.target.value);
                      setError(null);
                    }}
                    placeholder={
                      noAplica
                        ? "Explique por qué esta actividad no aplica…"
                        : ""
                    }
                    disabled={guardando}
                  />
                </div>

                {error && (
                  <div className="alert alert-danger" role="alert">
                    {error.status && (
                      <small className="d-block mb-1">
                        Respuesta del servidor · HTTP {error.status}
                      </small>
                    )}
                    <pre
                      className="mb-0"
                      style={{
                        whiteSpace: "pre-wrap",
                        fontFamily: "inherit",
                        color: "inherit",
                      }}
                    >
                      {error.texto}
                    </pre>
                  </div>
                )}

                <button
                  type="submit"
                  className="btn btn-primary btn-user btn-block"
                  disabled={guardando}
                >
                  {guardando ? "Guardando…" : "Guardar"}
                </button>
              </form>
            </div>
          </div>

          <Oms
            idTarea={props.idTarea}
            idSolicitud={props.idSolicitud}
            idEvaluador={props.idEvaluador}
            idInstitucion={props.idInstitucion}
            nombreTarea={props.nombreTarea}
          />
        </div>
      </ReactModal>
    </div>
  );
}

export default CambioEstadoTareas;
